import React, {Component} from 'react'
import KoszykService from "../KoszykService";
import AppConfig from "../../AppConfig";
import {Link} from "react-router-dom";

export default class NumerWczytany extends Component {

    constructor(props) {
        super(props);
        this.state = {
            faktura: false,
            loading: true
        }
    }


    componentDidMount() {
        for (let i = 0; i < this.props.biletData.length; i++) {
            if (this.props.biletData[i].typDok.indexOf('Faktura') > -1) {
                this.setState({faktura: true, loading: false})
            } else {
                this.setState({loading: false})
            }
        }
    }

    render() {
        return <div>
            <div className="row" style={{alignItems: 'center', width: '90%', margin: '0 auto'}}>
                <div className="col-12">
                    {this.state.loading ? <div style={{paddingTop: 10, textAlign: 'center', color: '#58b13d'}}>
                        <div className="loaderDim"><i className="fa fa-spinner fa-pulse fa-2x fa-fw"> </i></div>
                    </div> : <div className="row">
                        <div className={'col-12'}>
                            <h2 className="text-center" style={{fontWeight: 'bold'}}>Dokumenty dla biletu</h2>
                        </div>
                        <div className="col-12">
                            <hr/>
                            <p style={{fontWeight: 'normal'}}>Wygenerowanie faktury VAT jest możliwe tylko i wyłącznie
                                po uprzednim podaniu numeru NIP w procesie zakupu biletów.
                                Aby wygenerować fakturę VAT należy podać numer biletu dostępny w wiadomości e-mail
                                zawierającej zakupione bilety.</p>
                            <hr/>
                        </div>
                        <div className={'col-12'}>Dostępne dokumenty:</div>
                        {this.props.biletData.map((item, index) => {
                            return <div className={'col-12'}>
                                <div className={'row'}
                                     style={{
                                         borderRadius: 5,
                                         margin: 5,
                                         border: '1px solid #efefef',
                                         lineHeight: '40px'
                                     }}>
                                    <div className={'col-sm-3'}>{item.typDok}</div>
                                    <div className={'col-sm-7'}>{item.numerfaktury}</div>
                                    {item.typDok.indexOf('Faktura') > -1 ? <div className={'col-sm-2 text-right'}>
                                        <a href={AppConfig.HOST_API() + 'client/api/faktury/generujFakture/biletJednorazowy/' + this.props.idBi + '/' + item.tab + '/' + item.symNum}>
                                            <button className={'btn btn-sm btn-success'}>Pobierz fakturę
                                            </button>
                                        </a>
                                    </div> : <div className={'col-sm-2 text-right'}>
                                        {this.state.faktura || item.typDok.indexOf('Korekta') > -1  ? null : <button className={'btn btn-sm'}
                                                style={{background: '#ffc107', color: '#fff'}}
                                                onClick={() => {
                                                    this.props.setDokumentItem(item);
                                                    this.props.setCheckFirma()
                                                }}>Zamień na fakturę
                                        </button>}
                                    </div>}
                                </div>
                            </div>
                        })}
                    </div>}
                </div>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/koszyk/fakturyComponents/NumerWczytany.js